/* Consent-aware GA4: never collect form contents or URL queries. */
(() => {
  'use strict';
  const id = 'G-VW5TXDHW1C';
  const key = 'andriali-enquiry-pending-v1';
  const types = {sample: 'sample_request', documents: 'technical_document_request', project: 'project_enquiry'};
  let started = false;
  let viewed = false;
  const allowed = () => {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  };
  const clear = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const safeLocation = location.origin + location.pathname;
  let referrer = '';
  try { referrer = new URL(document.referrer).origin; } catch (_) {}
  const parameters = {
    page_location: safeLocation,
    page_referrer: referrer,
    page_title: location.pathname === '/search' ? 'Search | Andriali Contract' : document.title,
    send_to: id
  };
  function trackSuccess() {
    if (!allowed() || !document.querySelector('[data-andriali-enquiry-success]')) return;
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(key)); } catch (_) {}
    clear();
    if (!pending || !Object.hasOwn(types, pending.type) || pending.path !== location.pathname ||
        Date.now() - pending.time < 0 || Date.now() - pending.time > 1800000) return;
    window.gtag('event', types[pending.type], {...parameters, enquiry_type: pending.type});
  }
  function syncConsent() {
    const permit = allowed();
    window['ga-disable-' + id] = !permit;
    if (!permit) {
      clear();
      if (started) window.gtag('consent', 'update', {analytics_storage: 'denied'});
      return;
    }
    if (!started) {
      started = true;
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag('consent', 'default', {analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied'});
      window.gtag('js', new Date());
      window.gtag('config', id, {...parameters, send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false});
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
      document.head.appendChild(script);
    } else window.gtag('consent', 'update', {analytics_storage: 'granted'});
    if (!viewed) { viewed = true; window.gtag('event', 'page_view', parameters); }
    trackSuccess();
  }
  document.querySelectorAll('form[data-andriali-enquiry-form]').forEach(form => {
    form.addEventListener('submit', () => {
      clear();
      if (!allowed() || !form.checkValidity()) return;
      const selector = form.querySelector('[name="contact[request_type]"]');
      const type = selector ? selector.value : 'project';
      if (!Object.hasOwn(types, type)) return;
      try { sessionStorage.setItem(key, JSON.stringify({type, time: Date.now(), path: location.pathname})); } catch (_) {}
    });
  });
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify && window.Shopify.customerPrivacy) syncConsent();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) syncConsent(); });
  }
})();
